// frontend/src/components/EmailVerification.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const EmailVerification = () => {
  const { token } = useParams();
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(`/api/auth/verify/${token}`, {
          method: 'GET',
        });
        const data = await response.json();

        if (response.ok) {
          setMessage('Email vérifié avec succès ! Vous pouvez maintenant vous connecter.');
          navigate('/');
        } else {
          setMessage(data.message || 'Erreur lors de la vérification du token.');
          setTimeout(() => navigate('/'), 3000);
        }
      } catch (error) {
        setMessage('Erreur de connexion au serveur.');
      }
    };
    verifyEmail();
  }, [token, navigate]);

  return (<div style={{ color: 'red', fontWeight: 'bold', margin: '0.5rem 0' }}>
    {message}
  </div>);
};

export default EmailVerification;
